import classNames from "classnames"
import { isValid } from "date-fns"

export const isValidDate = (date: Date | null): date is Date => {
  return date !== null && isValid(date)
}

export const createMonthDate = (timestamp: number): Date | null => {
  const date = new Date(timestamp)
  return isValidDate(date) ? date : null
}

export const getMonthBoundary = (date: Date, isEndOfMonth = false): Date => {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth() + (isEndOfMonth ? 1 : 0),
    isEndOfMonth ? 0 : 1,
  )
}

export const isSameMonth = (date1: Date, date2: Date): boolean => {
  return (
    date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCFullYear() === date2.getUTCFullYear()
  )
}

export const getDayClassName = (
  day: Date,
  selectedStartDate: Date | null,
  selectedEndDate: Date | null,
  styles: { [key: string]: string },
): string => {
  const classes = [styles.day]
  const dayTime = day.getTime()
  const startTime = selectedStartDate?.getTime()
  const endTime = selectedEndDate?.getTime()

  if (startTime && dayTime === startTime) {
    classes.push(styles.startDay)
  }

  if (
    (endTime && dayTime === endTime) ||
    (startTime && dayTime === startTime && !selectedEndDate)
  ) {
    classes.push(styles.endDay)
  }

  if (startTime && endTime && dayTime > startTime && dayTime < endTime) {
    classes.push(styles.selectedDay)
  }

  if (day.getDay() === 0) classes.push(styles.sunday)
  if (day.getDay() === 6) classes.push(styles.saturday)

  return classNames(classes)
}
